import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIIconDuotone() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Duotone Icons '}
									<small>{'1200+ duotone icons from Iconify Solr'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="usage" className="mb-5">
									<h4>{'Usage'}</h4>
									<p>
										{
											' Access over 1,200 duotone icons from Iconify’s Solr collection. Combine two tones in a single icon to add depth and style to your interface while keeping a lightweight SVG format. Please read the official '
										}
										<a href="https://icon-sets.iconify.design/solar/" target="_blank" rel="noreferrer">
											{'Iconify Solr'}
										</a>
										{' documentation for the full list of icons. '}
									</p>
									<div className="card">
										<div data-scrollbar="true" data-height="55vh">
											<div className="card-body">
												<div className="row gx-0 gy-3 small fw-semibold">
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:4k-bold-duotone"
														></iconify-icon>
														<span>{'solar:4k-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:accessibility-bold-duotone"
														></iconify-icon>
														<span>{'solar:accessibility-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:accumulator-bold-duotone"
														></iconify-icon>
														<span>{'solar:accumulator-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:add-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:add-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:add-folder-bold-duotone"
														></iconify-icon>
														<span>{'solar:add-folder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:add-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:add-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:adhesive-plaster-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:adhesive-plaster-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:adhesive-plaster-bold-duotone"
														></iconify-icon>
														<span>{'solar:adhesive-plaster-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-case-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-case-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-case-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-case-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-case-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-case-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-case-open-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-case-open-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:airbuds-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:airbuds-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-pause-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-pause-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-play-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-play-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-sleep-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-sleep-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alarm-turn-off-bold-duotone"
														></iconify-icon>
														<span>{'solar:alarm-turn-off-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:album-bold-duotone"
														></iconify-icon>
														<span>{'solar:album-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-bottom-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-bottom-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-horizonta-spacing-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-horizonta-spacing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-horizontal-center-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-horizontal-center-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-top-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-top-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-vertical-center-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-vertical-center-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:align-vertical-spacing-bold-duotone"
														></iconify-icon>
														<span>{'solar:align-vertical-spacing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:alt-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-down-minimlistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-down-minimlistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:archive-up-minimlistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:archive-up-minimlistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:armchair-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:armchair-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:armchair-bold-duotone"
														></iconify-icon>
														<span>{'solar:armchair-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-left-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-left-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-left-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-left-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-right-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-right-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-right-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-right-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-to-down-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-to-down-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-to-down-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-to-down-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-to-top-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-to-top-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-to-top-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-to-top-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:asteroid-bold-duotone"
														></iconify-icon>
														<span>{'solar:asteroid-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:atom-bold-duotone"
														></iconify-icon>
														<span>{'solar:atom-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:augmented-reality-bold-duotone"
														></iconify-icon>
														<span>{'solar:augmented-reality-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:backpack-bold-duotone"
														></iconify-icon>
														<span>{'solar:backpack-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:backspace-bold-duotone"
														></iconify-icon>
														<span>{'solar:backspace-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bacteria-bold-duotone"
														></iconify-icon>
														<span>{'solar:bacteria-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-5-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-5-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-music-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-music-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-music-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-music-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bag-smile-bold-duotone"
														></iconify-icon>
														<span>{'solar:bag-smile-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:balloon-bold-duotone"
														></iconify-icon>
														<span>{'solar:balloon-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:balls-bold-duotone"
														></iconify-icon>
														<span>{'solar:balls-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:banknote-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:banknote-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:banknote-bold-duotone"
														></iconify-icon>
														<span>{'solar:banknote-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bar-chair-bold-duotone"
														></iconify-icon>
														<span>{'solar:bar-chair-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:basketball-bold-duotone"
														></iconify-icon>
														<span>{'solar:basketball-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bath-bold-duotone"
														></iconify-icon>
														<span>{'solar:bath-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-charge-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-charge-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-full-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-full-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-full-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-full-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-half-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-half-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-half-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-half-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-low-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-low-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:battery-low-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:battery-low-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bed-bold-duotone"
														></iconify-icon>
														<span>{'solar:bed-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bedside-table-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:bedside-table-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bedside-table-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:bedside-table-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bedside-table-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:bedside-table-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bedside-table-bold-duotone"
														></iconify-icon>
														<span>{'solar:bedside-table-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bell-bing-bold-duotone"
														></iconify-icon>
														<span>{'solar:bell-bing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bell-bold-duotone"
														></iconify-icon>
														<span>{'solar:bell-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bell-off-bold-duotone"
														></iconify-icon>
														<span>{'solar:bell-off-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:benzene-ring-bold-duotone"
														></iconify-icon>
														<span>{'solar:benzene-ring-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bicycling-bold-duotone"
														></iconify-icon>
														<span>{'solar:bicycling-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bicycling-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:bicycling-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bill-bold-duotone"
														></iconify-icon>
														<span>{'solar:bill-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bill-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:bill-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bill-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:bill-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bill-list-bold-duotone"
														></iconify-icon>
														<span>{'solar:bill-list-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:black-hole-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:black-hole-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:black-hole-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:black-hole-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:black-hole-bold-duotone"
														></iconify-icon>
														<span>{'solar:black-hole-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bluetooth-bold-duotone"
														></iconify-icon>
														<span>{'solar:bluetooth-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bluetooth-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:bluetooth-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bluetooth-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:bluetooth-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bluetooth-wave-bold-duotone"
														></iconify-icon>
														<span>{'solar:bluetooth-wave-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:body-bold-duotone"
														></iconify-icon>
														<span>{'solar:body-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:body-shape-bold-duotone"
														></iconify-icon>
														<span>{'solar:body-shape-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:body-shape-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:body-shape-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bolt-bold-duotone"
														></iconify-icon>
														<span>{'solar:bolt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bolt-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:bolt-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bomb-bold-duotone"
														></iconify-icon>
														<span>{'solar:bomb-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bomb-emoji-bold-duotone"
														></iconify-icon>
														<span>{'solar:bomb-emoji-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bomb-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:bomb-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bone-bold-duotone"
														></iconify-icon>
														<span>{'solar:bone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bone-broken-bold-duotone"
														></iconify-icon>
														<span>{'solar:bone-broken-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bone-crack-bold-duotone"
														></iconify-icon>
														<span>{'solar:bone-crack-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bones-bold-duotone"
														></iconify-icon>
														<span>{'solar:bones-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bonfire-bold-duotone"
														></iconify-icon>
														<span>{'solar:bonfire-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:book-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:book-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:book-bold-duotone"
														></iconify-icon>
														<span>{'solar:book-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:book-bookmark-bold-duotone"
														></iconify-icon>
														<span>{'solar:book-bookmark-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:book-bookmark-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:book-bookmark-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:book-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:book-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bookmark-bold-duotone"
														></iconify-icon>
														<span>{'solar:bookmark-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bookmark-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:bookmark-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bookmark-opened-bold-duotone"
														></iconify-icon>
														<span>{'solar:bookmark-opened-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bookmark-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:bookmark-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bookmark-square-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:bookmark-square-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:boombox-bold-duotone"
														></iconify-icon>
														<span>{'solar:boombox-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bottle-bold-duotone"
														></iconify-icon>
														<span>{'solar:bottle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bowling-bold-duotone"
														></iconify-icon>
														<span>{'solar:bowling-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:box-bold-duotone"
														></iconify-icon>
														<span>{'solar:box-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:box-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:box-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:branching-paths-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:branching-paths-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:branching-paths-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:branching-paths-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:broom-bold-duotone"
														></iconify-icon>
														<span>{'solar:broom-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bug-bold-duotone"
														></iconify-icon>
														<span>{'solar:bug-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bug-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:bug-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:buildings-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:buildings-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:buildings-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:buildings-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:buildings-bold-duotone"
														></iconify-icon>
														<span>{'solar:buildings-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:bus-bold-duotone"
														></iconify-icon>
														<span>{'solar:bus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calculator-bold-duotone"
														></iconify-icon>
														<span>{'solar:calculator-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calculator-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:calculator-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-date-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-date-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-mark-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-mark-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:calendar-search-bold-duotone"
														></iconify-icon>
														<span>{'solar:calendar-search-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-cancel-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-cancel-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-cancel-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-cancel-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-chat-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-chat-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-chat-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-chat-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-dropped-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-dropped-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-dropped-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-dropped-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-medicine-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-medicine-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:call-medicine-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:call-medicine-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:camera-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:camera-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:camera-bold-duotone"
														></iconify-icon>
														<span>{'solar:camera-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:camera-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:camera-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:camera-rotate-bold-duotone"
														></iconify-icon>
														<span>{'solar:camera-rotate-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:camera-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:camera-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-recive-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-recive-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-search-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-search-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-send-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-send-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:card-transfer-bold-duotone"
														></iconify-icon>
														<span>{'solar:card-transfer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cardholder-bold-duotone"
														></iconify-icon>
														<span>{'solar:cardholder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-5-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-5-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-large-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-large-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-large-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-large-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-large-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-large-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-large-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-large-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-large-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-large-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cart-plus-bold-duotone"
														></iconify-icon>
														<span>{'solar:cart-plus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:case-bold-duotone"
														></iconify-icon>
														<span>{'solar:case-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:case-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:case-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:case-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:case-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:case-round-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:case-round-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cash-out-bold-duotone"
														></iconify-icon>
														<span>{'solar:cash-out-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cassette-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:cassette-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cassette-bold-duotone"
														></iconify-icon>
														<span>{'solar:cassette-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cat-bold-duotone"
														></iconify-icon>
														<span>{'solar:cat-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chair-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:chair-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chair-bold-duotone"
														></iconify-icon>
														<span>{'solar:chair-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chandelier-bold-duotone"
														></iconify-icon>
														<span>{'solar:chandelier-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chart-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:chart-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chart-bold-duotone"
														></iconify-icon>
														<span>{'solar:chart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chart-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:chart-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-dots-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-dots-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-call-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-call-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-dots-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-dots-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-like-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-like-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-money-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-money-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-round-video-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-round-video-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-arrow-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-arrow-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-call-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-call-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-code-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-code-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-square-like-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-square-like-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chat-unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:chat-unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:check-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:check-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:check-read-bold-duotone"
														></iconify-icon>
														<span>{'solar:check-read-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:check-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:check-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:checklist-bold-duotone"
														></iconify-icon>
														<span>{'solar:checklist-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:checklist-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:checklist-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chef-hat-bold-duotone"
														></iconify-icon>
														<span>{'solar:chef-hat-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chef-hat-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:chef-hat-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:chef-hat-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:chef-hat-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:circle-bottom-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:circle-bottom-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:circle-bottom-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:circle-bottom-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:circle-top-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:circle-top-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:circle-top-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:circle-top-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:city-bold-duotone"
														></iconify-icon>
														<span>{'solar:city-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-edit-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-edit-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-open-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-open-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-open-play-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-open-play-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-play-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-play-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clapperboard-text-bold-duotone"
														></iconify-icon>
														<span>{'solar:clapperboard-text-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-list-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-list-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clipboard-text-bold-duotone"
														></iconify-icon>
														<span>{'solar:clipboard-text-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clock-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:clock-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clock-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:clock-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:close-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:close-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:close-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:close-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:closet-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:closet-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:closet-bold-duotone"
														></iconify-icon>
														<span>{'solar:closet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-bolt-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-bolt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-bolt-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-bolt-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-download-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-download-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-file-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-file-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-minus-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-minus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-plus-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-plus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-rain-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-rain-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-snowfall-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-snowfall-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-snowfall-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-snowfall-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-storage-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-storage-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-storm-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-storm-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-sun-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-sun-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-sun-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-sun-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-upload-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-upload-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-waterdrop-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-waterdrop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloud-waterdrops-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloud-waterdrops-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clouds-bold-duotone"
														></iconify-icon>
														<span>{'solar:clouds-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cloudy-moon-bold-duotone"
														></iconify-icon>
														<span>{'solar:cloudy-moon-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:clound-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:clound-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-file-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-file-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-scan-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-scan-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:code-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:code-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:colour-tuneing-bold-duotone"
														></iconify-icon>
														<span>{'solar:colour-tuneing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:command-bold-duotone"
														></iconify-icon>
														<span>{'solar:command-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:compass-big-bold-duotone"
														></iconify-icon>
														<span>{'solar:compass-big-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:compass-bold-duotone"
														></iconify-icon>
														<span>{'solar:compass-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:compass-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:compass-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:condicioner-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:condicioner-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:condicioner-bold-duotone"
														></iconify-icon>
														<span>{'solar:condicioner-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:confetti-bold-duotone"
														></iconify-icon>
														<span>{'solar:confetti-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:confetti-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:confetti-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:confounded-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:confounded-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:confounded-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:confounded-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:copy-bold-duotone"
														></iconify-icon>
														<span>{'solar:copy-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:copyright-bold-duotone"
														></iconify-icon>
														<span>{'solar:copyright-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:corkscrew-bold-duotone"
														></iconify-icon>
														<span>{'solar:corkscrew-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cosmetic-bold-duotone"
														></iconify-icon>
														<span>{'solar:cosmetic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:course-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:course-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:course-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:course-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cpu-bold-duotone"
														></iconify-icon>
														<span>{'solar:cpu-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cpu-bolt-bold-duotone"
														></iconify-icon>
														<span>{'solar:cpu-bolt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:creative-commons-bold-duotone"
														></iconify-icon>
														<span>{'solar:creative-commons-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crop-bold-duotone"
														></iconify-icon>
														<span>{'solar:crop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crop-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:crop-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crown-bold-duotone"
														></iconify-icon>
														<span>{'solar:crown-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crown-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:crown-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crown-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:crown-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:crown-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:crown-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-first-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-first-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-hot-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-hot-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-music-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-music-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-paper-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-paper-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cup-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:cup-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cursor-bold-duotone"
														></iconify-icon>
														<span>{'solar:cursor-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:cursor-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:cursor-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:danger-bold-duotone"
														></iconify-icon>
														<span>{'solar:danger-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:danger-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:danger-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:danger-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:danger-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:danger-triangle-bold-duotone"
														></iconify-icon>
														<span>{'solar:danger-triangle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:database-bold-duotone"
														></iconify-icon>
														<span>{'solar:database-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:delivery-bold-duotone"
														></iconify-icon>
														<span>{'solar:delivery-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:devices-bold-duotone"
														></iconify-icon>
														<span>{'solar:devices-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:diagram-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:diagram-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:diagram-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:diagram-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dialog-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:dialog-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dialog-bold-duotone"
														></iconify-icon>
														<span>{'solar:dialog-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:diploma-bold-duotone"
														></iconify-icon>
														<span>{'solar:diploma-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:diploma-verified-bold-duotone"
														></iconify-icon>
														<span>{'solar:diploma-verified-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:diskette-bold-duotone"
														></iconify-icon>
														<span>{'solar:diskette-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dislike-bold-duotone"
														></iconify-icon>
														<span>{'solar:dislike-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:display-bold-duotone"
														></iconify-icon>
														<span>{'solar:display-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dna-bold-duotone"
														></iconify-icon>
														<span>{'solar:dna-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:document-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:document-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:document-bold-duotone"
														></iconify-icon>
														<span>{'solar:document-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:document-medicine-bold-duotone"
														></iconify-icon>
														<span>{'solar:document-medicine-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:document-text-bold-duotone"
														></iconify-icon>
														<span>{'solar:document-text-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:documents-bold-duotone"
														></iconify-icon>
														<span>{'solar:documents-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:documents-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:documents-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dollar-bold-duotone"
														></iconify-icon>
														<span>{'solar:dollar-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dollar-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:dollar-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:donut-bitten-bold-duotone"
														></iconify-icon>
														<span>{'solar:donut-bitten-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:donut-bold-duotone"
														></iconify-icon>
														<span>{'solar:donut-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:double-alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:double-alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:double-alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:double-alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:double-alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:double-alt-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:double-alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:double-alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:download-bold-duotone"
														></iconify-icon>
														<span>{'solar:download-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:download-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:download-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:download-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:download-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:download-twice-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:download-twice-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dropper-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:dropper-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dropper-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:dropper-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dropper-bold-duotone"
														></iconify-icon>
														<span>{'solar:dropper-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dropper-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:dropper-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dropper-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:dropper-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbell-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbell-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbell-large-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbell-large-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbell-large-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbell-large-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbell-small-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbell-small-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbells-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbells-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:dumbbells-bold-duotone"
														></iconify-icon>
														<span>{'solar:dumbbells-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:earth-bold-duotone"
														></iconify-icon>
														<span>{'solar:earth-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:electric-refueling-bold-duotone"
														></iconify-icon>
														<span>{'solar:electric-refueling-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:emoji-funny-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:emoji-funny-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:emoji-funny-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:emoji-funny-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:end-call-bold-duotone"
														></iconify-icon>
														<span>{'solar:end-call-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:end-call-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:end-call-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eraser-bold-duotone"
														></iconify-icon>
														<span>{'solar:eraser-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eraser-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:eraser-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eraser-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:eraser-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:euro-bold-duotone"
														></iconify-icon>
														<span>{'solar:euro-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:exit-bold-duotone"
														></iconify-icon>
														<span>{'solar:exit-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:explicit-bold-duotone"
														></iconify-icon>
														<span>{'solar:explicit-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:export-bold-duotone"
														></iconify-icon>
														<span>{'solar:export-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:expressionless-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:expressionless-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:expressionless-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:expressionless-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eye-bold-duotone"
														></iconify-icon>
														<span>{'solar:eye-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eye-closed-bold-duotone"
														></iconify-icon>
														<span>{'solar:eye-closed-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:eye-scan-bold-duotone"
														></iconify-icon>
														<span>{'solar:eye-scan-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:face-scan-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:face-scan-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:face-scan-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:face-scan-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:facemask-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:facemask-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:facemask-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:facemask-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:feed-bold-duotone"
														></iconify-icon>
														<span>{'solar:feed-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ferris-wheel-bold-duotone"
														></iconify-icon>
														<span>{'solar:ferris-wheel-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:figma-bold-duotone"
														></iconify-icon>
														<span>{'solar:figma-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:figma-file-bold-duotone"
														></iconify-icon>
														<span>{'solar:figma-file-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-corrupted-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-corrupted-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-download-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-download-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-favourite-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-favourite-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-send-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-send-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-smile-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-smile-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:file-text-bold-duotone"
														></iconify-icon>
														<span>{'solar:file-text-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:filter-bold-duotone"
														></iconify-icon>
														<span>{'solar:filter-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:filters-bold-duotone"
														></iconify-icon>
														<span>{'solar:filters-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fire-bold-duotone"
														></iconify-icon>
														<span>{'solar:fire-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fire-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:fire-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fire-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:fire-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flag-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:flag-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flag-bold-duotone"
														></iconify-icon>
														<span>{'solar:flag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flame-bold-duotone"
														></iconify-icon>
														<span>{'solar:flame-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flash-drive-bold-duotone"
														></iconify-icon>
														<span>{'solar:flash-drive-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flashlight-bold-duotone"
														></iconify-icon>
														<span>{'solar:flashlight-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flashlight-on-bold-duotone"
														></iconify-icon>
														<span>{'solar:flashlight-on-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flip-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:flip-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:flip-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:flip-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:floor-lamp-bold-duotone"
														></iconify-icon>
														<span>{'solar:floor-lamp-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:floor-lamp-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:floor-lamp-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fog-bold-duotone"
														></iconify-icon>
														<span>{'solar:fog-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-cloud-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-cloud-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-error-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-error-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-favourite-bookmark-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-favourite-bookmark-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-favourite-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-favourite-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-open-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-open-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-path-connect-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-path-connect-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-security-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-security-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:folder-with-files-bold-duotone"
														></iconify-icon>
														<span>{'solar:folder-with-files-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:football-bold-duotone"
														></iconify-icon>
														<span>{'solar:football-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:forbidden-bold-duotone"
														></iconify-icon>
														<span>{'solar:forbidden-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:forbidden-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:forbidden-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:forward-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:forward-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fridge-bold-duotone"
														></iconify-icon>
														<span>{'solar:fridge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:fuel-bold-duotone"
														></iconify-icon>
														<span>{'solar:fuel-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:full-screen-bold-duotone"
														></iconify-icon>
														<span>{'solar:full-screen-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:full-screen-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:full-screen-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:full-screen-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:full-screen-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-download-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-download-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-edit-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-edit-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-favourite-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-favourite-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-send-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-send-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gallery-wide-bold-duotone"
														></iconify-icon>
														<span>{'solar:gallery-wide-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gameboy-bold-duotone"
														></iconify-icon>
														<span>{'solar:gameboy-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gamepad-bold-duotone"
														></iconify-icon>
														<span>{'solar:gamepad-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gamepad-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:gamepad-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gamepad-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:gamepad-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gamepad-no-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:gamepad-no-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gamepad-old-bold-duotone"
														></iconify-icon>
														<span>{'solar:gamepad-old-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:garage-bold-duotone"
														></iconify-icon>
														<span>{'solar:garage-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gas-station-bold-duotone"
														></iconify-icon>
														<span>{'solar:gas-station-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ghost-bold-duotone"
														></iconify-icon>
														<span>{'solar:ghost-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ghost-smile-bold-duotone"
														></iconify-icon>
														<span>{'solar:ghost-smile-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gift-bold-duotone"
														></iconify-icon>
														<span>{'solar:gift-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:glasses-bold-duotone"
														></iconify-icon>
														<span>{'solar:glasses-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:global-bold-duotone"
														></iconify-icon>
														<span>{'solar:global-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:globus-bold-duotone"
														></iconify-icon>
														<span>{'solar:globus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:golf-bold-duotone"
														></iconify-icon>
														<span>{'solar:golf-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:gps-bold-duotone"
														></iconify-icon>
														<span>{'solar:gps-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-down-new-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-down-new-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-new-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-new-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-new-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-new-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:graph-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:graph-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hamburger-menu-bold-duotone"
														></iconify-icon>
														<span>{'solar:hamburger-menu-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hand-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:hand-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hand-money-bold-duotone"
														></iconify-icon>
														<span>{'solar:hand-money-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hand-pills-bold-duotone"
														></iconify-icon>
														<span>{'solar:hand-pills-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hand-shake-bold-duotone"
														></iconify-icon>
														<span>{'solar:hand-shake-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hand-stars-bold-duotone"
														></iconify-icon>
														<span>{'solar:hand-stars-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hanger-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:hanger-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hanger-bold-duotone"
														></iconify-icon>
														<span>{'solar:hanger-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hashtag-bold-duotone"
														></iconify-icon>
														<span>{'solar:hashtag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hashtag-chat-bold-duotone"
														></iconify-icon>
														<span>{'solar:hashtag-chat-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hashtag-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:hashtag-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hashtag-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:hashtag-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:headphones-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:headphones-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:headphones-round-sound-bold-duotone"
														></iconify-icon>
														<span>{'solar:headphones-round-sound-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:headphones-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:headphones-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:headphones-square-sound-bold-duotone"
														></iconify-icon>
														<span>{'solar:headphones-square-sound-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:health-bold-duotone"
														></iconify-icon>
														<span>{'solar:health-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-broken-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-broken-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-lock-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-lock-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-pulse-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-pulse-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-pulse-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-pulse-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-shine-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-shine-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:heart-unlock-bold-duotone"
														></iconify-icon>
														<span>{'solar:heart-unlock-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hearts-bold-duotone"
														></iconify-icon>
														<span>{'solar:hearts-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:help-bold-duotone"
														></iconify-icon>
														<span>{'solar:help-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:high-definition-bold-duotone"
														></iconify-icon>
														<span>{'solar:high-definition-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:high-quality-bold-duotone"
														></iconify-icon>
														<span>{'solar:high-quality-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hiking-bold-duotone"
														></iconify-icon>
														<span>{'solar:hiking-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hiking-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:hiking-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hiking-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:hiking-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:history-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:history-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:history-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:history-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:history-bold-duotone"
														></iconify-icon>
														<span>{'solar:history-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-add-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-add-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-angle-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-angle-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-smile-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-smile-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-smile-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-smile-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-wifi-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-wifi-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:home-wifi-bold-duotone"
														></iconify-icon>
														<span>{'solar:home-wifi-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hospital-bold-duotone"
														></iconify-icon>
														<span>{'solar:hospital-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hourglass-bold-duotone"
														></iconify-icon>
														<span>{'solar:hourglass-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:hourglass-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:hourglass-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:import-bold-duotone"
														></iconify-icon>
														<span>{'solar:import-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-archive-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-archive-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-in-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-in-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-out-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-out-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:inbox-unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:inbox-unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:incognito-bold-duotone"
														></iconify-icon>
														<span>{'solar:incognito-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:incoming-call-bold-duotone"
														></iconify-icon>
														<span>{'solar:incoming-call-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:incoming-call-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:incoming-call-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:infinity-bold-duotone"
														></iconify-icon>
														<span>{'solar:infinity-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:info-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:info-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:info-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:info-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:iphone-bold-duotone"
														></iconify-icon>
														<span>{'solar:iphone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:jar-of-pills-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:jar-of-pills-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:jar-of-pills-bold-duotone"
														></iconify-icon>
														<span>{'solar:jar-of-pills-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-minimalistic-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-minimalistic-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-minimalistic-square-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-minimalistic-square-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-minimalistic-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-minimalistic-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:key-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:key-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:keyboard-bold-duotone"
														></iconify-icon>
														<span>{'solar:keyboard-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:kick-scooter-bold-duotone"
														></iconify-icon>
														<span>{'solar:kick-scooter-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ladle-bold-duotone"
														></iconify-icon>
														<span>{'solar:ladle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lamp-bold-duotone"
														></iconify-icon>
														<span>{'solar:lamp-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:laptop-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:laptop-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:laptop-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:laptop-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:laptop-bold-duotone"
														></iconify-icon>
														<span>{'solar:laptop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:laptop-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:laptop-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:layers-bold-duotone"
														></iconify-icon>
														<span>{'solar:layers-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:layers-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:layers-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:leaf-bold-duotone"
														></iconify-icon>
														<span>{'solar:leaf-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:letter-bold-duotone"
														></iconify-icon>
														<span>{'solar:letter-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:letter-opened-bold-duotone"
														></iconify-icon>
														<span>{'solar:letter-opened-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:letter-unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:letter-unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:library-bold-duotone"
														></iconify-icon>
														<span>{'solar:library-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lightbulb-bold-duotone"
														></iconify-icon>
														<span>{'solar:lightbulb-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lightbulb-bolt-bold-duotone"
														></iconify-icon>
														<span>{'solar:lightbulb-bolt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lightbulb-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:lightbulb-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lightning-bold-duotone"
														></iconify-icon>
														<span>{'solar:lightning-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:like-bold-duotone"
														></iconify-icon>
														<span>{'solar:like-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-broken-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-broken-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-broken-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-broken-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-round-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-round-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:link-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:link-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-arrow-down-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-arrow-down-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-arrow-up-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-arrow-up-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-check-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-check-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-cross-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-cross-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-down-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-down-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-heart-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-heart-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:list-up-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:list-up-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-keyhole-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-keyhole-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-keyhole-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-keyhole-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-keyhole-minimalistic-unlocked-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:lock-keyhole-minimalistic-unlocked-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-keyhole-unlocked-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-keyhole-unlocked-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-password-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-password-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-password-unlocked-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-password-unlocked-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:lock-unlocked-bold-duotone"
														></iconify-icon>
														<span>{'solar:lock-unlocked-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:login-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:login-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:login-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:login-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:login-bold-duotone"
														></iconify-icon>
														<span>{'solar:login-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:logout-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:logout-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:logout-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:logout-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:logout-bold-duotone"
														></iconify-icon>
														<span>{'solar:logout-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magic-stick-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:magic-stick-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magic-stick-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:magic-stick-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magic-stick-bold-duotone"
														></iconify-icon>
														<span>{'solar:magic-stick-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnet-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnet-wave-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnet-wave-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnifer-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnifer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnifer-bug-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnifer-bug-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnifer-zoom-in-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnifer-zoom-in-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:magnifer-zoom-out-bold-duotone"
														></iconify-icon>
														<span>{'solar:magnifer-zoom-out-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mailbox-bold-duotone"
														></iconify-icon>
														<span>{'solar:mailbox-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-arrow-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-arrow-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-favourite-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-favourite-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-hospital-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-hospital-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-rotate-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-rotate-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-school-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-school-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-search-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-search-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:map-point-wave-bold-duotone"
														></iconify-icon>
														<span>{'solar:map-point-wave-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mask-happly-bold-duotone"
														></iconify-icon>
														<span>{'solar:mask-happly-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mask-sad-bold-duotone"
														></iconify-icon>
														<span>{'solar:mask-sad-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:masks-bold-duotone"
														></iconify-icon>
														<span>{'solar:masks-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:maximize-bold-duotone"
														></iconify-icon>
														<span>{'solar:maximize-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:maximize-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:maximize-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:maximize-square-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:maximize-square-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:maximize-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:maximize-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:maximize-square-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:maximize-square-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-ribbon-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-ribbon-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-ribbon-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-ribbon-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-ribbons-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-ribbons-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-star-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-star-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medal-star-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:medal-star-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:medical-kit-bold-duotone"
														></iconify-icon>
														<span>{'solar:medical-kit-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:meditation-bold-duotone"
														></iconify-icon>
														<span>{'solar:meditation-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:meditation-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:meditation-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:men-bold-duotone"
														></iconify-icon>
														<span>{'solar:men-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mention-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:mention-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mention-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:mention-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:menu-dots-bold-duotone"
														></iconify-icon>
														<span>{'solar:menu-dots-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:menu-dots-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:menu-dots-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:menu-dots-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:menu-dots-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:microphone-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:microphone-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:microphone-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:microphone-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:microphone-bold-duotone"
														></iconify-icon>
														<span>{'solar:microphone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:microphone-large-bold-duotone"
														></iconify-icon>
														<span>{'solar:microphone-large-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimalistic-magnifer-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimalistic-magnifer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimalistic-magnifer-bug-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimalistic-magnifer-bug-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimalistic-magnifer-zoom-in-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:minimalistic-magnifer-zoom-in-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimalistic-magnifer-zoom-out-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:minimalistic-magnifer-zoom-out-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimize-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimize-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimize-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimize-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimize-square-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimize-square-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimize-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimize-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minimize-square-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:minimize-square-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minus-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:minus-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:minus-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:minus-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mirror-bold-duotone"
														></iconify-icon>
														<span>{'solar:mirror-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mirror-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:mirror-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mirror-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:mirror-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:money-bag-bold-duotone"
														></iconify-icon>
														<span>{'solar:money-bag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:monitor-bold-duotone"
														></iconify-icon>
														<span>{'solar:monitor-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:monitor-camera-bold-duotone"
														></iconify-icon>
														<span>{'solar:monitor-camera-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:monitor-smartphone-bold-duotone"
														></iconify-icon>
														<span>{'solar:monitor-smartphone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:moon-bold-duotone"
														></iconify-icon>
														<span>{'solar:moon-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:moon-fog-bold-duotone"
														></iconify-icon>
														<span>{'solar:moon-fog-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:moon-sleep-bold-duotone"
														></iconify-icon>
														<span>{'solar:moon-sleep-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:moon-stars-bold-duotone"
														></iconify-icon>
														<span>{'solar:moon-stars-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mouse-bold-duotone"
														></iconify-icon>
														<span>{'solar:mouse-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mouse-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:mouse-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:mouse-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:mouse-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:move-to-folder-bold-duotone"
														></iconify-icon>
														<span>{'solar:move-to-folder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:multiple-forward-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:multiple-forward-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:multiple-forward-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:multiple-forward-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-library-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-library-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-library-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-library-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-slider-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-slider-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-note-slider-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-note-slider-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:music-notes-bold-duotone"
														></iconify-icon>
														<span>{'solar:music-notes-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:muted-bold-duotone"
														></iconify-icon>
														<span>{'solar:muted-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notebook-bold-duotone"
														></iconify-icon>
														<span>{'solar:notebook-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notebook-bookmark-bold-duotone"
														></iconify-icon>
														<span>{'solar:notebook-bookmark-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notebook-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:notebook-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notebook-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:notebook-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notes-bold-duotone"
														></iconify-icon>
														<span>{'solar:notes-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notes-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:notes-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notification-lines-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:notification-lines-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notification-remove-bold-duotone"
														></iconify-icon>
														<span>{'solar:notification-remove-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notification-unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:notification-unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:notification-unread-lines-bold-duotone"
														></iconify-icon>
														<span>{'solar:notification-unread-lines-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:object-scan-bold-duotone"
														></iconify-icon>
														<span>{'solar:object-scan-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:outgoing-call-bold-duotone"
														></iconify-icon>
														<span>{'solar:outgoing-call-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:outgoing-call-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:outgoing-call-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:oven-mitts-bold-duotone"
														></iconify-icon>
														<span>{'solar:oven-mitts-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:oven-mitts-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:oven-mitts-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paint-roller-bold-duotone"
														></iconify-icon>
														<span>{'solar:paint-roller-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:palette-bold-duotone"
														></iconify-icon>
														<span>{'solar:palette-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:palette-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:palette-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pallete-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pallete-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:panorama-bold-duotone"
														></iconify-icon>
														<span>{'solar:panorama-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paper-bin-bold-duotone"
														></iconify-icon>
														<span>{'solar:paper-bin-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paperclip-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:paperclip-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paperclip-bold-duotone"
														></iconify-icon>
														<span>{'solar:paperclip-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paperclip-rounded-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:paperclip-rounded-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paperclip-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:paperclip-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paragraph-spacing-bold-duotone"
														></iconify-icon>
														<span>{'solar:paragraph-spacing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:passport-bold-duotone"
														></iconify-icon>
														<span>{'solar:passport-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:passport-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:passport-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:password-bold-duotone"
														></iconify-icon>
														<span>{'solar:password-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:password-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:password-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:password-minimalistic-input-bold-duotone"
														></iconify-icon>
														<span>{'solar:password-minimalistic-input-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pause-bold-duotone"
														></iconify-icon>
														<span>{'solar:pause-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pause-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:pause-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:paw-bold-duotone"
														></iconify-icon>
														<span>{'solar:paw-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pen-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pen-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pen-bold-duotone"
														></iconify-icon>
														<span>{'solar:pen-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pen-new-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:pen-new-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pen-new-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:pen-new-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:people-nearby-bold-duotone"
														></iconify-icon>
														<span>{'solar:people-nearby-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:perfume-bold-duotone"
														></iconify-icon>
														<span>{'solar:perfume-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:phone-bold-duotone"
														></iconify-icon>
														<span>{'solar:phone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:phone-calling-bold-duotone"
														></iconify-icon>
														<span>{'solar:phone-calling-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:phone-calling-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:phone-calling-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:phone-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:phone-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pie-chart-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pie-chart-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pie-chart-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:pie-chart-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pie-chart-bold-duotone"
														></iconify-icon>
														<span>{'solar:pie-chart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pill-bold-duotone"
														></iconify-icon>
														<span>{'solar:pill-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pills-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pills-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pills-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:pills-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pills-bold-duotone"
														></iconify-icon>
														<span>{'solar:pills-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pin-bold-duotone"
														></iconify-icon>
														<span>{'solar:pin-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pin-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:pin-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pin-list-bold-duotone"
														></iconify-icon>
														<span>{'solar:pin-list-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pip-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pip-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pip-bold-duotone"
														></iconify-icon>
														<span>{'solar:pip-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pipette-bold-duotone"
														></iconify-icon>
														<span>{'solar:pipette-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plaaylist-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:plaaylist-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plain-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:plain-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plain-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:plain-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plain-bold-duotone"
														></iconify-icon>
														<span>{'solar:plain-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:planet-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:planet-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:planet-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:planet-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:planet-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:planet-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:planet-bold-duotone"
														></iconify-icon>
														<span>{'solar:planet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plate-bold-duotone"
														></iconify-icon>
														<span>{'solar:plate-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:play-bold-duotone"
														></iconify-icon>
														<span>{'solar:play-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:play-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:play-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:play-stream-bold-duotone"
														></iconify-icon>
														<span>{'solar:play-stream-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:playback-speed-bold-duotone"
														></iconify-icon>
														<span>{'solar:playback-speed-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:playlist-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:playlist-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:playlist-bold-duotone"
														></iconify-icon>
														<span>{'solar:playlist-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:playlist-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:playlist-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:playlist-minimalistic-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:playlist-minimalistic-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plug-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:plug-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:plus-minus-bold-duotone"
														></iconify-icon>
														<span>{'solar:plus-minus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:podcast-bold-duotone"
														></iconify-icon>
														<span>{'solar:podcast-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:point-on-map-bold-duotone"
														></iconify-icon>
														<span>{'solar:point-on-map-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:point-on-map-perspective-bold-duotone"
														></iconify-icon>
														<span>{'solar:point-on-map-perspective-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:posts-carousel-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:posts-carousel-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:posts-carousel-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:posts-carousel-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:power-bold-duotone"
														></iconify-icon>
														<span>{'solar:power-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:presentation-graph-bold-duotone"
														></iconify-icon>
														<span>{'solar:presentation-graph-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:printer-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:printer-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:printer-bold-duotone"
														></iconify-icon>
														<span>{'solar:printer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:printer-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:printer-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:programming-bold-duotone"
														></iconify-icon>
														<span>{'solar:programming-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:projector-bold-duotone"
														></iconify-icon>
														<span>{'solar:projector-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pulse-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:pulse-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:pulse-bold-duotone"
														></iconify-icon>
														<span>{'solar:pulse-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:qr-code-bold-duotone"
														></iconify-icon>
														<span>{'solar:qr-code-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:question-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:question-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:question-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:question-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:quit-full-screen-bold-duotone"
														></iconify-icon>
														<span>{'solar:quit-full-screen-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:quit-full-screen-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:quit-full-screen-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:quit-full-screen-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:quit-full-screen-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:quit-pip-bold-duotone"
														></iconify-icon>
														<span>{'solar:quit-pip-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:radar-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:radar-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:radar-bold-duotone"
														></iconify-icon>
														<span>{'solar:radar-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:radial-blur-bold-duotone"
														></iconify-icon>
														<span>{'solar:radial-blur-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:radio-bold-duotone"
														></iconify-icon>
														<span>{'solar:radio-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:radio-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:radio-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ranking-bold-duotone"
														></iconify-icon>
														<span>{'solar:ranking-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:recive-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:recive-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:recive-twice-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:recive-twice-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:record-bold-duotone"
														></iconify-icon>
														<span>{'solar:record-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:record-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:record-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:record-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:record-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:record-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:record-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:reel-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:reel-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:reel-bold-duotone"
														></iconify-icon>
														<span>{'solar:reel-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:refresh-bold-duotone"
														></iconify-icon>
														<span>{'solar:refresh-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:refresh-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:refresh-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:refresh-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:refresh-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:remote-controller-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:remote-controller-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:remote-controller-bold-duotone"
														></iconify-icon>
														<span>{'solar:remote-controller-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:remote-controller-minimalistic-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:remote-controller-minimalistic-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:remove-folder-bold-duotone"
														></iconify-icon>
														<span>{'solar:remove-folder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:reorder-bold-duotone"
														></iconify-icon>
														<span>{'solar:reorder-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:repeat-bold-duotone"
														></iconify-icon>
														<span>{'solar:repeat-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:repeat-one-bold-duotone"
														></iconify-icon>
														<span>{'solar:repeat-one-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:repeat-one-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:repeat-one-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:reply-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:reply-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:reply-bold-duotone"
														></iconify-icon>
														<span>{'solar:reply-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:restart-bold-duotone"
														></iconify-icon>
														<span>{'solar:restart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:restart-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:restart-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:restart-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:restart-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:revote-bold-duotone"
														></iconify-icon>
														<span>{'solar:revote-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-10-seconds-back-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-10-seconds-back-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-10-seconds-forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-10-seconds-forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-15-seconds-back-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-15-seconds-back-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-15-seconds-forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-15-seconds-forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-5-seconds-back-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-5-seconds-back-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-5-seconds-forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-5-seconds-forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-back-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-back-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-back-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-back-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rewind-forward-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:rewind-forward-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rocket-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:rocket-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rocket-bold-duotone"
														></iconify-icon>
														<span>{'solar:rocket-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rolling-pin-bold-duotone"
														></iconify-icon>
														<span>{'solar:rolling-pin-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-alt-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-left-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-left-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-left-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-left-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-right-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-right-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-right-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-right-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-double-alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-double-alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-double-alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-double-alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-double-alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-double-alt-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-double-alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-double-alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-graph-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-graph-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-sort-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-sort-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-sort-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-sort-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-transfer-diagonal-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-transfer-diagonal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-transfer-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-transfer-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:round-transfer-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:round-transfer-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rounded-magnifer-bold-duotone"
														></iconify-icon>
														<span>{'solar:rounded-magnifer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rounded-magnifer-bug-bold-duotone"
														></iconify-icon>
														<span>{'solar:rounded-magnifer-bug-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rounded-magnifer-zoom-in-bold-duotone"
														></iconify-icon>
														<span>{'solar:rounded-magnifer-zoom-in-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rounded-magnifer-zoom-out-bold-duotone"
														></iconify-icon>
														<span>{'solar:rounded-magnifer-zoom-out-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:route-bold-duotone"
														></iconify-icon>
														<span>{'solar:route-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:routing-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:routing-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:routing-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:routing-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:routing-bold-duotone"
														></iconify-icon>
														<span>{'solar:routing-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ruble-bold-duotone"
														></iconify-icon>
														<span>{'solar:ruble-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:rugby-bold-duotone"
														></iconify-icon>
														<span>{'solar:rugby-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ruler-angular-bold-duotone"
														></iconify-icon>
														<span>{'solar:ruler-angular-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ruler-bold-duotone"
														></iconify-icon>
														<span>{'solar:ruler-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ruler-cross-pen-bold-duotone"
														></iconify-icon>
														<span>{'solar:ruler-cross-pen-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ruler-pen-bold-duotone"
														></iconify-icon>
														<span>{'solar:ruler-pen-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:running-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:running-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:running-bold-duotone"
														></iconify-icon>
														<span>{'solar:running-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:running-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:running-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sad-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:sad-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sad-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:sad-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:safe-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:safe-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:safe-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:safe-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:safe-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:safe-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sale-bold-duotone"
														></iconify-icon>
														<span>{'solar:sale-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sale-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:sale-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:satellite-bold-duotone"
														></iconify-icon>
														<span>{'solar:satellite-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scale-bold-duotone"
														></iconify-icon>
														<span>{'solar:scale-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scanner-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:scanner-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scanner-bold-duotone"
														></iconify-icon>
														<span>{'solar:scanner-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scissors-bold-duotone"
														></iconify-icon>
														<span>{'solar:scissors-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scissors-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:scissors-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:scooter-bold-duotone"
														></iconify-icon>
														<span>{'solar:scooter-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:screen-share-bold-duotone"
														></iconify-icon>
														<span>{'solar:screen-share-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:screencast-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:screencast-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:screencast-bold-duotone"
														></iconify-icon>
														<span>{'solar:screencast-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sd-card-bold-duotone"
														></iconify-icon>
														<span>{'solar:sd-card-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:send-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:send-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:send-twice-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:send-twice-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-path-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-path-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-square-cloud-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-square-cloud-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:server-square-update-bold-duotone"
														></iconify-icon>
														<span>{'solar:server-square-update-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:settings-bold-duotone"
														></iconify-icon>
														<span>{'solar:settings-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:settings-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:settings-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:share-bold-duotone"
														></iconify-icon>
														<span>{'solar:share-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:share-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:share-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-keyhole-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-keyhole-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-keyhole-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-keyhole-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-minus-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-minus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-network-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-network-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-plus-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-plus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-user-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-user-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shield-warning-bold-duotone"
														></iconify-icon>
														<span>{'solar:shield-warning-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shock-absorber-bold-duotone"
														></iconify-icon>
														<span>{'solar:shock-absorber-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shop-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:shop-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shop-bold-duotone"
														></iconify-icon>
														<span>{'solar:shop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shop-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:shop-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:shuffle-bold-duotone"
														></iconify-icon>
														<span>{'solar:shuffle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sidebar-code-bold-duotone"
														></iconify-icon>
														<span>{'solar:sidebar-code-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sidebar-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:sidebar-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:siderbar-bold-duotone"
														></iconify-icon>
														<span>{'solar:siderbar-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:signpost-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:signpost-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:signpost-bold-duotone"
														></iconify-icon>
														<span>{'solar:signpost-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sim-card-bold-duotone"
														></iconify-icon>
														<span>{'solar:sim-card-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sim-card-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:sim-card-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sim-cards-bold-duotone"
														></iconify-icon>
														<span>{'solar:sim-cards-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:siren-bold-duotone"
														></iconify-icon>
														<span>{'solar:siren-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:siren-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:siren-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skateboard-bold-duotone"
														></iconify-icon>
														<span>{'solar:skateboard-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skateboarding-bold-duotone"
														></iconify-icon>
														<span>{'solar:skateboarding-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skateboarding-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:skateboarding-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skip-next-bold-duotone"
														></iconify-icon>
														<span>{'solar:skip-next-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skip-previous-bold-duotone"
														></iconify-icon>
														<span>{'solar:skip-previous-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:skirt-bold-duotone"
														></iconify-icon>
														<span>{'solar:skirt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slash-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:slash-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slash-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:slash-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sledgehammer-bold-duotone"
														></iconify-icon>
														<span>{'solar:sledgehammer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sleeping-bold-duotone"
														></iconify-icon>
														<span>{'solar:sleeping-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sleeping-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:sleeping-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sleeping-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:sleeping-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slider-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:slider-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slider-minimalistic-horizontal-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:slider-minimalistic-horizontal-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slider-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:slider-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:slider-vertical-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:slider-vertical-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-home-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-home-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-home-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-home-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-speaker-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-speaker-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-speaker-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-speaker-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-speaker-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-speaker-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-vacuum-cleaner-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-vacuum-cleaner-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smart-vacuum-cleaner-bold-duotone"
														></iconify-icon>
														<span>{'solar:smart-vacuum-cleaner-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-rotate-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-rotate-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-rotate-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-rotate-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-rotate-orientation-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:smartphone-rotate-orientation-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-update-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-update-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smartphone-vibration-bold-duotone"
														></iconify-icon>
														<span>{'solar:smartphone-vibration-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smile-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:smile-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:smile-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:smile-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:snowflake-bold-duotone"
														></iconify-icon>
														<span>{'solar:snowflake-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:socket-bold-duotone"
														></iconify-icon>
														<span>{'solar:socket-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sofa-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:sofa-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sofa-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:sofa-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sofa-bold-duotone"
														></iconify-icon>
														<span>{'solar:sofa-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-by-alphabet-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-by-alphabet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-by-time-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-by-time-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-from-bottom-to-top-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-from-bottom-to-top-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-from-top-to-bottom-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-from-top-to-bottom-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sort-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:sort-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:soundwave-bold-duotone"
														></iconify-icon>
														<span>{'solar:soundwave-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:soundwave-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:soundwave-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:soundwave-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:soundwave-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:speaker-bold-duotone"
														></iconify-icon>
														<span>{'solar:speaker-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:speaker-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:speaker-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:special-effects-bold-duotone"
														></iconify-icon>
														<span>{'solar:special-effects-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:spedometer-low-bold-duotone"
														></iconify-icon>
														<span>{'solar:spedometer-low-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:spedometer-max-bold-duotone"
														></iconify-icon>
														<span>{'solar:spedometer-max-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:spedometer-middle-bold-duotone"
														></iconify-icon>
														<span>{'solar:spedometer-middle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-academic-cap-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-academic-cap-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-academic-cap-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-academic-cap-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-alt-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-left-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-left-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-left-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-left-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-right-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-right-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-right-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-right-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-bottom-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-bottom-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-bottom-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-bottom-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-double-alt-arrow-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-double-alt-arrow-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-double-alt-arrow-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-double-alt-arrow-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-double-alt-arrow-right-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:square-double-alt-arrow-right-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-double-alt-arrow-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-double-alt-arrow-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-forward-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-forward-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-share-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-share-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-sort-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-sort-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-sort-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-sort-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-top-down-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-top-down-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-top-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-top-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-transfer-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-transfer-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:square-transfer-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:square-transfer-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ssd-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:ssd-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ssd-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:ssd-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-fall-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-fall-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-fall-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-fall-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-fall-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-fall-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-fall-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-fall-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-rainbow-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-rainbow-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-ring-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-ring-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-rings-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-rings-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:star-shine-bold-duotone"
														></iconify-icon>
														<span>{'solar:star-shine-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stars-bold-duotone"
														></iconify-icon>
														<span>{'solar:stars-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stars-line-bold-duotone"
														></iconify-icon>
														<span>{'solar:stars-line-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stars-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:stars-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:station-bold-duotone"
														></iconify-icon>
														<span>{'solar:station-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:station-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:station-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stethoscope-bold-duotone"
														></iconify-icon>
														<span>{'solar:stethoscope-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sticker-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:sticker-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sticker-smile-circle-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:sticker-smile-circle-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sticker-smile-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:sticker-smile-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sticker-smile-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:sticker-smile-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sticker-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:sticker-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stop-bold-duotone"
														></iconify-icon>
														<span>{'solar:stop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stop-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:stop-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stopwatch-bold-duotone"
														></iconify-icon>
														<span>{'solar:stopwatch-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stopwatch-pause-bold-duotone"
														></iconify-icon>
														<span>{'solar:stopwatch-pause-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stopwatch-play-bold-duotone"
														></iconify-icon>
														<span>{'solar:stopwatch-play-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stream-bold-duotone"
														></iconify-icon>
														<span>{'solar:stream-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:streets-bold-duotone"
														></iconify-icon>
														<span>{'solar:streets-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:streets-map-point-bold-duotone"
														></iconify-icon>
														<span>{'solar:streets-map-point-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:streets-navigation-bold-duotone"
														></iconify-icon>
														<span>{'solar:streets-navigation-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stretching-bold-duotone"
														></iconify-icon>
														<span>{'solar:stretching-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:stretching-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:stretching-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:structure-bold-duotone"
														></iconify-icon>
														<span>{'solar:structure-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:subtitles-bold-duotone"
														></iconify-icon>
														<span>{'solar:subtitles-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suitcase-bold-duotone"
														></iconify-icon>
														<span>{'solar:suitcase-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suitcase-lines-bold-duotone"
														></iconify-icon>
														<span>{'solar:suitcase-lines-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suitcase-tag-bold-duotone"
														></iconify-icon>
														<span>{'solar:suitcase-tag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sun-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:sun-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sun-bold-duotone"
														></iconify-icon>
														<span>{'solar:sun-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sun-fog-bold-duotone"
														></iconify-icon>
														<span>{'solar:sun-fog-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sunrise-bold-duotone"
														></iconify-icon>
														<span>{'solar:sunrise-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:sunset-bold-duotone"
														></iconify-icon>
														<span>{'solar:sunset-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suspension-bold-duotone"
														></iconify-icon>
														<span>{'solar:suspension-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suspension-bolt-bold-duotone"
														></iconify-icon>
														<span>{'solar:suspension-bolt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:suspension-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:suspension-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:swimming-bold-duotone"
														></iconify-icon>
														<span>{'solar:swimming-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:syringe-bold-duotone"
														></iconify-icon>
														<span>{'solar:syringe-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:t-shirt-bold-duotone"
														></iconify-icon>
														<span>{'solar:t-shirt-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tablet-bold-duotone"
														></iconify-icon>
														<span>{'solar:tablet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tag-bold-duotone"
														></iconify-icon>
														<span>{'solar:tag-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tag-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:tag-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tag-price-bold-duotone"
														></iconify-icon>
														<span>{'solar:tag-price-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:target-bold-duotone"
														></iconify-icon>
														<span>{'solar:target-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tea-cup-bold-duotone"
														></iconify-icon>
														<span>{'solar:tea-cup-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:telescope-bold-duotone"
														></iconify-icon>
														<span>{'solar:telescope-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:temperature-bold-duotone"
														></iconify-icon>
														<span>{'solar:temperature-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tennis-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:tennis-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tennis-bold-duotone"
														></iconify-icon>
														<span>{'solar:tennis-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:test-tube-bold-duotone"
														></iconify-icon>
														<span>{'solar:test-tube-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:test-tube-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:test-tube-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-bold-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-bold-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-bold-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-bold-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-bold-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-bold-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-cross-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-cross-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-cross-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-cross-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-field-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-field-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-field-focus-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-field-focus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-italic-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-italic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-italic-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-italic-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-italic-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-italic-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-selection-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-selection-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-underline-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-underline-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-underline-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-underline-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:text-underline-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:text-underline-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:thermometer-bold-duotone"
														></iconify-icon>
														<span>{'solar:thermometer-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:three-squares-bold-duotone"
														></iconify-icon>
														<span>{'solar:three-squares-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ticker-star-bold-duotone"
														></iconify-icon>
														<span>{'solar:ticker-star-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ticket-bold-duotone"
														></iconify-icon>
														<span>{'solar:ticket-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ticket-sale-bold-duotone"
														></iconify-icon>
														<span>{'solar:ticket-sale-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:to-pip-bold-duotone"
														></iconify-icon>
														<span>{'solar:to-pip-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tornado-bold-duotone"
														></iconify-icon>
														<span>{'solar:tornado-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tornado-small-bold-duotone"
														></iconify-icon>
														<span>{'solar:tornado-small-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:traffic-bold-duotone"
														></iconify-icon>
														<span>{'solar:traffic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:traffic-economy-bold-duotone"
														></iconify-icon>
														<span>{'solar:traffic-economy-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tram-bold-duotone"
														></iconify-icon>
														<span>{'solar:tram-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:transfer-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:transfer-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:transfer-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:transfer-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:translation-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:translation-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:translation-bold-duotone"
														></iconify-icon>
														<span>{'solar:translation-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:transmission-bold-duotone"
														></iconify-icon>
														<span>{'solar:transmission-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:transmission-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:transmission-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:transmission-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:transmission-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:trash-bin-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:trash-bin-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:trash-bin-minimalistic-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:trash-bin-minimalistic-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:trash-bin-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:trash-bin-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:trash-bin-trash-bold-duotone"
														></iconify-icon>
														<span>{'solar:trash-bin-trash-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:treadmill-bold-duotone"
														></iconify-icon>
														<span>{'solar:treadmill-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:treadmill-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:treadmill-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:trellis-bold-duotone"
														></iconify-icon>
														<span>{'solar:trellis-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-square-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-square-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tuning-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:tuning-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:turntable-bold-duotone"
														></iconify-icon>
														<span>{'solar:turntable-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:turntable-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:turntable-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:turntable-music-note-bold-duotone"
														></iconify-icon>
														<span>{'solar:turntable-music-note-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:tv-bold-duotone"
														></iconify-icon>
														<span>{'solar:tv-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ufo-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:ufo-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ufo-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:ufo-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:ufo-bold-duotone"
														></iconify-icon>
														<span>{'solar:ufo-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:umbrella-bold-duotone"
														></iconify-icon>
														<span>{'solar:umbrella-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-left-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-left-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-left-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-left-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-left-round-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-left-round-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-left-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-left-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-right-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-right-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-right-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-right-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-right-round-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-right-round-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:undo-right-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:undo-right-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:unread-bold-duotone"
														></iconify-icon>
														<span>{'solar:unread-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-track-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-track-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-track-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-track-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:upload-twice-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:upload-twice-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:usb-bold-duotone"
														></iconify-icon>
														<span>{'solar:usb-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:usb-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:usb-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:usb-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:usb-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-block-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-block-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-block-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-block-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-check-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-check-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-circle-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-circle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-cross-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-cross-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-hand-up-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-hand-up-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-hands-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-hands-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-heart-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-heart-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-heart-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-heart-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-id-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-id-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-minus-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-minus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-minus-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-minus-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-plus-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-plus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-plus-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-plus-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-speak-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-speak-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:user-speak-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:user-speak-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:users-group-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:users-group-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:users-group-two-rounded-bold-duotone"
														></iconify-icon>
														<span>{'solar:users-group-two-rounded-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:verified-check-bold-duotone"
														></iconify-icon>
														<span>{'solar:verified-check-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-cut-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-cut-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-cut-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-cut-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-play-horizontal-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-play-horizontal-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-play-vertical-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-play-vertical-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-frame-replace-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-frame-replace-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:video-library-bold-duotone"
														></iconify-icon>
														<span>{'solar:video-library-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:videocamera-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:videocamera-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:videocamera-bold-duotone"
														></iconify-icon>
														<span>{'solar:videocamera-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:videocamera-record-bold-duotone"
														></iconify-icon>
														<span>{'solar:videocamera-record-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:vinyl-bold-duotone"
														></iconify-icon>
														<span>{'solar:vinyl-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:vinyl-record-bold-duotone"
														></iconify-icon>
														<span>{'solar:vinyl-record-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:virus-bold-duotone"
														></iconify-icon>
														<span>{'solar:virus-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volleyball-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:volleyball-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volleyball-bold-duotone"
														></iconify-icon>
														<span>{'solar:volleyball-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volume-bold-duotone"
														></iconify-icon>
														<span>{'solar:volume-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volume-cross-bold-duotone"
														></iconify-icon>
														<span>{'solar:volume-cross-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volume-knob-bold-duotone"
														></iconify-icon>
														<span>{'solar:volume-knob-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volume-loud-bold-duotone"
														></iconify-icon>
														<span>{'solar:volume-loud-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:volume-small-bold-duotone"
														></iconify-icon>
														<span>{'solar:volume-small-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wad-of-money-bold-duotone"
														></iconify-icon>
														<span>{'solar:wad-of-money-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:walking-bold-duotone"
														></iconify-icon>
														<span>{'solar:walking-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:walking-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:walking-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wallet-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:wallet-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wallet-bold-duotone"
														></iconify-icon>
														<span>{'solar:wallet-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wallet-money-bold-duotone"
														></iconify-icon>
														<span>{'solar:wallet-money-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wallpaper-bold-duotone"
														></iconify-icon>
														<span>{'solar:wallpaper-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:washing-machine-bold-duotone"
														></iconify-icon>
														<span>{'solar:washing-machine-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:washing-machine-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:washing-machine-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:watch-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:watch-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:watch-square-bold-duotone"
														></iconify-icon>
														<span>{'solar:watch-square-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:watch-square-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:watch-square-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:watch-square-minimalistic-charge-bold-duotone"
														></iconify-icon>
														<span>
															{'solar:watch-square-minimalistic-charge-bold-duotone'}
														</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:water-bold-duotone"
														></iconify-icon>
														<span>{'solar:water-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:water-sun-bold-duotone"
														></iconify-icon>
														<span>{'solar:water-sun-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:waterdrop-bold-duotone"
														></iconify-icon>
														<span>{'solar:waterdrop-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:waterdrops-bold-duotone"
														></iconify-icon>
														<span>{'solar:waterdrops-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:weigher-bold-duotone"
														></iconify-icon>
														<span>{'solar:weigher-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wheel-angle-bold-duotone"
														></iconify-icon>
														<span>{'solar:wheel-angle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wheel-bold-duotone"
														></iconify-icon>
														<span>{'solar:wheel-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:whisk-bold-duotone"
														></iconify-icon>
														<span>{'solar:whisk-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wi-fi-router-bold-duotone"
														></iconify-icon>
														<span>{'solar:wi-fi-router-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wi-fi-router-minimalistic-bold-duotone"
														></iconify-icon>
														<span>{'solar:wi-fi-router-minimalistic-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wi-fi-router-round-bold-duotone"
														></iconify-icon>
														<span>{'solar:wi-fi-router-round-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-2-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-2-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-3-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-3-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-4-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-4-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-5-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-5-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-6-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-6-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-add-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-add-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:widget-bold-duotone"
														></iconify-icon>
														<span>{'solar:widget-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wind-bold-duotone"
														></iconify-icon>
														<span>{'solar:wind-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:window-frame-bold-duotone"
														></iconify-icon>
														<span>{'solar:window-frame-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wineglass-bold-duotone"
														></iconify-icon>
														<span>{'solar:wineglass-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wineglass-triangle-bold-duotone"
														></iconify-icon>
														<span>{'solar:wineglass-triangle-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:winrar-bold-duotone"
														></iconify-icon>
														<span>{'solar:winrar-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:wireless-charge-bold-duotone"
														></iconify-icon>
														<span>{'solar:wireless-charge-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:women-bold-duotone"
														></iconify-icon>
														<span>{'solar:women-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:xxx-bold-duotone"
														></iconify-icon>
														<span>{'solar:xxx-bold-duotone'}</span>
													</div>
													<div className="col-lg-6 d-flex align-items-center">
														<iconify-icon
															className="me-2 fs-1"
															icon="solar:zip-file-bold-duotone"
														></iconify-icon>
														<span>{'solar:zip-file-bold-duotone'}</span>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-icon-duotone/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#usage" data-toggle="scroll-to">
											{'Usage'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIIconDuotone;
